import {FC} from 'react';

import {Button} from '@zoefin/design-system/v2';

import {
  getDesktopBackClassName,
  getDesktopBackInlineClassName,
  getMobileBackClassName,
} from '../../utils';

import {LayoutBackButtonsProps} from './types';

const LayoutBackButtons: FC<LayoutBackButtonsProps> = ({
  show,
  isAboutStep,
  ui,
  prev,
}) => {
  if (!show) return null;

  return (
    <>
      <div className={getMobileBackClassName(ui)}>
        {!isAboutStep && (
          <Button
            as="button"
            config={{
              type: 'link',
              shape: 'square',
              icon: {name: 'fa-light fa-arrow-left'},
            }}
            aria-label="Back"
            onClick={() => prev()}
          />
        )}
      </div>
      <div className={getDesktopBackClassName(ui)}>
        <Button
          as="button"
          config={{
            type: isAboutStep ? 'secondary' : 'link',
            icon: isAboutStep
              ? undefined
              : {
                  name: 'fa-light fa-arrow-left',
                  position: 'left',
                },
          }}
          onClick={() => prev()}>
          {isAboutStep ? 'Go back' : 'Back'}
        </Button>
      </div>
      <div className={getDesktopBackInlineClassName(ui)}>
        <Button as="button" config={{type: 'secondary'}} onClick={() => prev()}>
          Back
        </Button>
      </div>
    </>
  );
};

export default LayoutBackButtons;
